export default __webpack_public_path__ + "maps-examples-fill-pattern-thumbnail-480-c724a970d52f16ce9a62d3f37529c3e2.png";